<p-toast class="no-summary" position="top-center" [key]="GLOBAL_TOAST_KEY" />
<!-- Main Router -->
<div id="body" [ngClass]="(cssClasses$ | async) ?? ''">
  <router-outlet />
  @if (isBrowser) {
    <p-confirmDialog [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [closable]="true" />
  }
  <app-loading-spinner [fullScreen]="true" [loading]="loading$ | async" />
</div>
